import { useState } from 'react'
import Icon from '../../Icon/Icon'
import ButtonCinestar from '../ButtonCinestar/ButtonCinestar'

import './ButtonRefreshment.scss'

const ButtonRefreshment = () => {
    const [quantity, setQuantity] = useState(0)

    const classNamePrimary =
        'button-refreshment bg-white text-magentaSecondary d-flex justify-content-center align-items-center'

    const classNameSecondary = 'bg-transparent border-0 px-2'

    return (
        <>
            {quantity === 0 ? (
                <ButtonCinestar variant="primary-v1" iconLeft="plus" onClick={() => setQuantity(1)} className="pe-3">
                    Pridat
                </ButtonCinestar>
            ) : (
                <div className={classNamePrimary}>
                    <button
                        onClick={() => setQuantity((prevQuantity) => prevQuantity - 1)}
                        className={classNameSecondary}
                    >
                        <Icon name={'minus-blue'} />
                    </button>
                    <span>{quantity} x</span>
                    <button
                        onClick={() => setQuantity((prevQuantity) => prevQuantity + 1)}
                        className={classNameSecondary}
                    >
                        <Icon name={'plus-blue'} />
                    </button>
                </div>
            )}
        </>
    )
}

export default ButtonRefreshment
